import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdminSlackComponent } from './admin-slack.component';

const routes: Routes = [
  {
    path: '',
    component: AdminSlackComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminSlackRoutingModule {}
